module.exports = __webpack_public_path__ + "media/app/images/pink-logo-fca4b9b0c3335bf0d7c7ffc0d637305c.svg";